
import React from 'react';
import { TabHeading } from './TabHeading.styled'
import { useSelector } from 'react-redux';

const TabHeadingComp = ({job_id, activeTab, handleTabClick, channel = '' }) => {
    
    const { personalDetailsData } =
        useSelector((state) => state.tenantSetting) || {};
  
    let col=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'rgba(42, 136, 107, 1)';    
    return (

        <TabHeading col={col}>
            <div
                className={activeTab === 'overViewTab' ? 'activePlanTab' : ''}
                onClick={() => handleTabClick('overViewTab')}
            >
                Overviews
            </div>
            {
                channel == 'enterprise' ? <></> :

                    <div
                        className={activeTab === 'Reach' ? 'activePlanTab' : ''}
                        onClick={() => handleTabClick('Reach')}
                    >
                        Reach
                    </div>
            }
            <div
                className={activeTab === 'sentimentsTab' ? 'activePlanTab' : ''}
                onClick={() => handleTabClick('sentimentsTab')}
            >
                Sentiments
            </div>
            {
                channel == 'enterprise' ? <></> :
                    <div
                        className={activeTab === 'insightTab' ? 'activePlanTab' : ''}
                        onClick={() => handleTabClick('insightTab')}
                    >
                        Insights
                    </div>
            }
            {
                typeof job_id === 'number' ?
                    <div
                        className={activeTab === 'clusterAnalysis' ? 'activePlanTab' : ''}
                        onClick={() => handleTabClick('clusterAnalysis')}
                    >
                        {/* Cluster Analysis */}
                        PerceptMap
                    </div>
                    :
                    <></>
            }

            {/* {

                channel == 'enterprise' ? <></> :

                    <div
                        className={activeTab === 'customAnalysis' ? 'activePlanTab' : ''}
                        onClick={() => handleTabClick('customAnalysis')}
                    >AskIQ
                        Custom Analysis
                    </div>
            } */}
            <div
                className={activeTab === 'reviewsTab' ? 'activePlanTab' : ''}
                onClick={() => handleTabClick('reviewsTab')}
            >
                {channel == 'enterprise' ? 'Reports ' : 'Posts'}
            </div>
        </TabHeading>
    );
};


export default TabHeadingComp;